module.exports = __webpack_public_path__ + "img/nt111-04-81-1.prt.b53c13c0.jpg";